export default __webpack_public_path__ + "static/media/menu-06-more-b.0022f423.svg";